import { Injectable, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { ConfigService } from "app/_core/services/config.service";
import { AppErrorState, setError } from "app/_store";
import { AppState } from "app/_store/app.state";
import { environment } from "environments/environment";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ErrorService implements OnDestroy {
	private unsubscribeAll: Subject<any>;
	constructor(
		private __appStore: Store<AppState>,
		private __router: Router,
		private __configService: ConfigService
	) {
		this.unsubscribeAll = new Subject();
	}

	ngOnDestroy() {
		this.unsubscribeAll.next(void 0);
		this.unsubscribeAll.complete();
	}

	checkMaintenace(product): void {
		this.__configService.getConfigFromDrupal().subscribe((config) => {
			const m = config.maintenance;
			const hasMaintenance =
				(product === "internet" && m.internet) ||
				(product === "energy" && m.energy) ||
				(product === "mobile" && m.mobile);
			if (!hasMaintenance) {
				return;
			}
			const error = <AppErrorState>{
				title: "Oops",
				msg: m.info.message,
				enableRequestCallback: false,
				navBackUrl: "https://www.dodo.com",
			};
			this.__appStore.dispatch(setError({ error }));
			this.__router.navigate(["/maintenance-error"]);
		});
	}
}
